import React from 'react';
import './Catering.css';

const Catering = () => {
  return (
    <div className="catering-container">
      <div className="catering-hero">
        <h1>Catering Made Easy</h1>
        <p>Order delicious food for your next event through our EZ Catering platform</p>
        <a 
          href="https://www.ezcater.com/catering/pvt/highlands-sports-bar-and-grill-3?fcv=1"
          target="_blank"
          rel="noopener noreferrer"
          className="order-button"
        >
          Order Catering Now
        </a>
      </div>
      
      <div className="catering-features">
        <div className="feature">
          <h3>Easy Online Ordering</h3>
          <p>Place your order quickly and easily through our trusted catering platform</p>
        </div>
        <div className="feature">
          <h3>Flexible Options</h3>
          <p>Choose from our full menu of appetizers, entrees, and party platters</p>
        </div>
        <div className="feature">
          <h3>Professional Service</h3>
          <p>Perfect for corporate events, parties, and special occasions</p>
        </div>
      </div>

      <div className="catering-cta">
        <h2>Ready to Order?</h2>
        <p>Visit our EZ Catering page to start your order</p>
        <a 
          href="https://www.ezcater.com/catering/pvt/highlands-sports-bar-and-grill-3?fcv=1"
          target="_blank"
          rel="noopener noreferrer"
          className="secondary-button"
        >
          View Full Catering Menu
        </a>
      </div>
    </div>
  );
};

export default Catering; 